import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDeviceSupportAlgorithms } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 设备支持算法列表
  deviceSupportAlgorithms: {
    data: [],
    query: {}
  }
};

// 查询设备支持算法列表
export const fetchDeviceSupportAlgorithms = createAsyncThunk(
  'ys7Algorithm/fetchDeviceSupportAlgorithms',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getDeviceSupportAlgorithms(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取设备支持算法列表失败');
    }
  }
);

const algorithmSlice = createSlice({
  name: 'ys7Algorithm',
  initialState: defaultState,
  reducers: {
    resetAlgorithmState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchDeviceSupportAlgorithms
      .addCase(fetchDeviceSupportAlgorithms.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.deviceSupportAlgorithms.query = action.meta.arg || {};
      })
      .addCase(fetchDeviceSupportAlgorithms.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.deviceSupportAlgorithms.data = action.payload?.data?.data || action.payload?.data || [];
        state.deviceSupportAlgorithms.query = action.payload?.query || {};
      })
      .addCase(fetchDeviceSupportAlgorithms.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.deviceSupportAlgorithms.data = [];
      });
  }
});

export const { resetAlgorithmState } = algorithmSlice.actions;
export default algorithmSlice.reducer;
